import FlightStatusBadge from './FlightStatusBadge';

export default FlightStatusBadge;
